<template>
    <div>
        <v-card flat>
            <v-card-title>
                <span class="text-h5">Solicitud Individual: {{ reference }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="3" sm="3" md="3" class="pb-0">
                            <v-autocomplete v-model="employee" :items="itemsEmployees" label="Empleado" outlined
                                auto-select-first :disabled="disableRef"></v-autocomplete>
                        </v-col>
                        <v-col cols="1" sm="1" md="1" class="pb-0">
                            <v-text-field v-model="quantity" label="Cantidad" outlined required
                                type="number"></v-text-field>
                        </v-col>
                        <v-col cols="2" sm="2" md="2" class="pb-0">
                            <v-autocomplete v-model="category" :items="itemsCategories" label="Producto"
                                auto-select-first outlined ref="cod"></v-autocomplete>
                        </v-col>

                        <v-col cols="2" sm="2" md="2" class="pb-0">
                            <v-autocomplete v-model="zone" label="Zona" outlined class="mb-3" :disabled="disableRef"
                                :items="zonesItems"></v-autocomplete>
                        </v-col>

                        <v-col cols="2" sm="2" md="2" class="pb-0">
                            <v-autocomplete v-model="note" label="Nota" outlined class="mb-3" :disabled="disableRef"
                                :items="noteItems"></v-autocomplete>
                        </v-col>

                        <v-col cols="2" sm="2" md="2" class="pb-0" v-if="this.note === 'Otros'">
                            <v-text-field v-model="noteOther" label="Detalles" outlined class="mb-3"
                                :disabled="disableRef"></v-text-field>
                        </v-col>

                        <v-col cols="1" sm="1" md="1">
                            <v-icon color="success" @click="onList" v-text="'mdi-check-outline'"
                                :disabled="!isNewItemOk"></v-icon> -
                            <v-icon v-if="disableRef" color="warning" @click="onEdit"
                                v-text="'mdi-circle-edit-outline'"></v-icon>
                        </v-col>
                    </v-row>

                    <v-data-table :headers="headers" :items="productsAggregate" class="elevation-1 custom-font">
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-icon small @click="deleteItem(item)">
                                mdi-delete
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-alert shaped dense dark type="info" v-if="info !== ''">
                    {{ info }}
                </v-alert>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancelStock">
                    Cancelar
                </v-btn>
                <v-btn :disabled="!isOk" color="blue darken-1" text @click="saveStock">
                    Enviar Solicitud
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>
<script>
import { getEmployees, getProducts, saveRequest, getCategories, getInventoryZonesItems } from '../dataApi'
import UserProfile from "../data";
export default {
    name: 'request',
    data: () => ({
        user: UserProfile.getUserData(),
        selectedRef: null,
        category: null,
        quantity: 0,
        employee: null,
        note: '',
        reference: `Sol-${Date.now().toString().slice(-7)}`,
        itemsCategories: [],
        itemsEmployees: [],
        employees: [],
        products: [],
        productsAggregate: [],
        disableRef: false,
        originLabel: null,
        noteOther: '',
        zone: null,
        zonesItems: [],
        headers: [
            { text: 'Empleado', value: 'employee' },
            { text: 'Cantidad', value: 'quantity' },
            { text: 'Producto', value: 'category' },
            { text: 'Observacion', value: 'note' },
            { text: "Acciones", value: "actions", sortable: false },
        ],
        info: "",
        noteItems: [
            { text: "Desgaste Natural", value: "Desgaste Natural" },
            { text: "Cambio de Talla", value: "Cambio de Talla" },
            { text: "Renovación Anual", value: "Renovación Anual" },
            { text: "Evento", value: "Evento" },
            { text: "Pérdida o Extravío", value: "Pérdida o Extravío" },
            { text: "Accidente", value: "Accidente" },
            { text: "Quemadura o Mancha", value: "Quemadura o Mancha" },
            { text: "Nuevo Ingreso", value: "Nuevo Ingreso" },
            { text: "Otros", value: "Otros" },
        ],
    }),

    methods: {
        async createdValuesItems() {
            this.itemsCategories = await getCategories();
            const { employees, employeesItems } = await getEmployees();
            this.employees = employees;
            this.itemsEmployees = employeesItems;
            this.zonesItems = await getInventoryZonesItems()
        },

        async onList() {
            const quantity = parseInt(this.quantity)
            const category = this.itemsCategories.find(category => category.value === this.category)

            const employee = this.itemsEmployees.find(employee => employee.value === this.employee)
            const exist = this.productsAggregate.findIndex(product => product.categoryId === this.category && product.employeeId === this.employee)
            if (exist !== -1) {
                this.productsAggregate[exist].quantity += quantity;
            } else {
                this.productsAggregate.push({
                    categoryId: this.category,
                    category: category.text,
                    quantity,
                    employeeId: this.employee,
                    employee: employee.text,
                    note: this.note === 'Otros' ? this.noteOther : this.note,
                    sex: employee.sex
                });
                console.log(this.productsAggregate)
            }
            this.quantity = 0;
            this.category = 0;
            this.disableRef = true;
        },
        deleteItem(item) {
            const index = this.productsAggregate.findIndex(product => product.id === item.id)
            if (index !== -1) {
                this.productsAggregate.splice(index, 1);
            }
        },
        onEdit() {
            this.disableRef = false;
            this.originLabel = null;
        },
        cancelStock() {
            this.$emit("closeModal")
        },
        async saveStock() {
            const stock = {
                items: [],
                ref: this.reference,
                zoneId: this.zone
            }
            this.productsAggregate.forEach(product => {
                console.log("product", product)
                stock.items.push({
                    categoryId: product.categoryId,
                    quantity: product.quantity,
                    finalEmployeeId: product.employeeId,
                    observation: product.note === 'Otros' ? product.noteOther : product.note,
                    sex: product.sex
                })
            })
            await saveRequest(stock)
            this.cancelStock()
        }
    },

    mounted() {
        this.createdValuesItems();
        console.log("ALEXANDER", this.user)
    },

    computed: {
        isNewItemOk() {
            return this.category !== 0 && parseInt(this.quantity) > 0;
        },
        isOk() {
            return (this.productsAggregate.length > 0 && this.employee !== null && this.reference != '');
        }
    },

    watch: {
        employee(newValue, value) {
            if (newValue === value || newValue === null) {
                this.info = ""
                return
            }
            const emp = this.employees.find(emp => emp.id === newValue)
            this.info = `Detalles de interes: Talla Pantalon: ${emp.sizePants} - 
                        Talla Calzado: ${emp.sizeMescal} - Talla Chaqueta: ${emp.sizeUniform}`
        }
    }
}
</script>